<template>
  <div class="how-to-play">
    <Banner
      :title="'HOW TO PLAY'"
      :class-banner="'common-banner'"
    />
    <div class="how-to-play__images first_row">
      <img src="@/assets/images/how-to-play/howtoplay-01.jpg" />
      <img src="@/assets/images/how-to-play/howtoplay-02.jpg" />
      <img src="@/assets/images/how-to-play/howtoplay-03.jpg" />
      <img src="@/assets/images/how-to-play/howtoplay-04.jpg" />
    </div>
    <div class="how-to-play__images second_row">
      <img src="@/assets/images/how-to-play/howtoplay-05.jpg" />
      <img src="@/assets/images/how-to-play/howtoplay-06.jpg" />
      <img src="@/assets/images/how-to-play/howtoplay-07.jpg" />
    </div>
    <!--<div class="how-to-play__via">-->
      <!--<div class="how-to-play__via-item">-->
        <!--<div class="how-to-play__via-item-title">REGISTER</div>-->
        <!--<div class="how-to-play__via-item-des">-->
          <!--Open Web Page of Loterie Vert Game. <br>-->
          <!--Register with Your Mobile Number <br>-->
          <!--Mandatory to be +18 and to use your own mobile number-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="how-to-play__via-item">-->
        <!--<div class="how-to-play__via-item-title">LOGIN</div>-->
        <!--<div class="how-to-play__via-item-des">-->
          <!--Follow Prompt messages via your mobile phone. <br>-->
          <!--Login to Web Page of Loterie Vert Game.-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="how-to-play__via-item">-->
        <!--<div class="how-to-play__via-item-title">Playing Options:</div>-->
        <!--<div class="how-to-play__via-item-des">-->
          <!--<strong>Option 1: </strong> <br>-->
          <!--<strong>Choose your own numbers:</strong> <br>-->
          <!--Choose your favourite numbers by selecting seven (7) numbers from each grid. <br>-->
          <!--<strong>Option 2: </strong> <br>-->
          <!--<strong>Choose Quick Pick numbers:</strong> <br>-->
          <!--Select the the Quick Pick box located at the bottom of each ticket <br>-->
          <!--[ Quick Pick means your numbers are randomly selected for you]-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="how-to-play__content">
      <div class="how-to-play__loterie-vert">
        <div class="how-to-play__loterie-vert-title">
          WINNING BIG WITH LOTERIE VERT
        </div>
        <div class="how-to-play__loterie-vert-des">
          The minimum number of matches you need to win a prize is 1 numbers. To win the
          jackpot you must match all 7 numbers
        </div>
        <div class="how-to-play__loterie-vert-table">
          <Table
            :fields="fields"
            :items="items"
            :is-pagination="false"
            :custom-class-container="'table-how-to-play'"
          />
          <div class="hr-table-bottom">
            <hr>
          </div>
          <div class="how-to-play__loterie-vert-note">* Estimated rollover amount is creased at a proportion of ticket sales.</div>
        </div>
      </div>
      <div class="how-to-play__information">
        <div class="how-to-play__information-content">
          <div class="how-to-play__information-title">DRAW TIMES & INFORMATION</div>
          <div class="how-to-play__information-des">Loto 7/28 drawings weekly</div>
          <div class="how-to-play__information-time">EVERY FRIDAY: 20:25</div>
          <div class="how-to-play__information-content-des">
            <p>Entries to each draw close at 19:00 on the day of the draw. The winning numbers are revealed on your Favorite Local TV Station at 10pm,
              and published on the Results page after the show.</p>
            <p>All you have to do is pick 7 unique numbers from 1 to 28. </p>
          </div>
        </div>
        <div class="how-to-play__information-content">
          <div class="how-to-play__information-title">COST OF ENTRY AND NUMBER OF TICKETS TO PURCHASE</div>
          <div class="how-to-play__information-content-des">
            <p>Each entry to win a possible Rs 1,000,000.00 and cost only Rs 30.00.</p>
            <p>Only one ticket can be purchased for each request although you can purchase multiple tickets for the same draw.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/common/banner';
import Table from '@/components/common/table/table';
export default {
  components: {
    Table,
    Banner
  },
  data() {
    return {
      fields: [
        {key: 'level', label: 'Level'},
        {key: 'matchHowToPlay', label: 'Match'},
        {key: 'prize', label: 'Prize'}
      ],
      items: [
        {level: 1, matchHowToPlay: 7, prize: 'Rs 1,000,000.00'},
        {level: 2, matchHowToPlay: 6, prize: 'Rs 500,000.00'},
        {level: 3, matchHowToPlay: 5, prize: 'Rs 200,000.00'},
        {level: 4, matchHowToPlay: 4, prize: 'Rs 73,000.00'},
        {level: 5, matchHowToPlay: 3, prize: 'Rs 3,000.00'},
        {level: 6, matchHowToPlay: 2, prize: 'Rs 1,000.00'},
        {level: 7, matchHowToPlay: 1, prize: 'Rs 500.00'}
      ]
    }
  }
}
</script>
